<template>
  <div
    v-if="developments"
    class="vh-100 w-100 relative bg-light-gray overflow-hidden"
  >
    <div class="relative h-100 w-100 fade-in">
      <GmapMap
        ref="map"
        :zoom="10"
        :options="map.options"
        map-type-id="roadmap"
        class="bg-dark-gray w-100 h-100"
        :center="{
          lat: parseFloat(map.lat),
          lng: parseFloat(map.lng)
        }"
      >
        <GmapMarker
          v-for="(marker, i) in markers"
          :key="i"
          :position="marker"
          :clickable="true"
          :draggable="false"
          :icon="getMarkerIcon(marker)"
          @click="selectMarker(marker)"
        />
      </GmapMap>
      <DevelopmentCard
        v-for="(development, index) in developments"
        :key="index"
        :active="active === development.title ? true : false"
        :content="development"
        :distance="developmentDistance"
        @close="close()"
      />
      <Filters
        :get-plots="getPlots"
        :developments="developments"
        @select="selectMarker"
      />
    </div>
  </div>
</template>
<script>
import MapStyle from '@/assets/json/gmaps-style-home-page.json'
import DevelopmentCard from '@/components/developments/DevelopmentCard.vue'
import Filters from '@/components/developments/Filters.vue'

const reject = require('lodash/reject')

export default {
  name: 'Developments',
  components: {
    DevelopmentCard,
    Filters
  },
  data () {
    return {
      developmentDistance: null,
      mapIndex: {
        lat: 53.5663632,
        lng: -2.7838088
      },
      active: null,
      map: {
        lat: 53.5663632,
        lng: -2.7838088,
        markers: {
          lh: {
            active: require('@/assets/img/map-marker-active-lh.png'),
            current: require('@/assets/img/map-marker-current-lh.png'),
            disabled: require('@/assets/img/map-marker-lh.png')
          },
          lq: {
            active: require('@/assets/img/map-marker-active-lq.png'),
            current: require('@/assets/img/map-marker-active-lq.png'),
            disabled: require('@/assets/img/map-marker-lq.png')
          }
        },
        options: {
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: false,
          disableDefaultUi: false,
          styles: MapStyle
        }
      }
    }
  },
  props: {
    focusId: {
      type: String,
      default: null
    }
  },
  computed: {
    developments () {
      if (this.$store.state.content) {
        return this.$store.state.content.developments
      } else {
        return null
      }
    },
    getPlots () {
      let array = []
      if (this.$store.state.content && this.developments) {
        this.developments.forEach(development => {
          array.push(this.$store.getters.getPlots(development.crm))
        })
        return array
      } else {
        return null
      }
    },
    getDevelopmentsFilters () {
      if (this.getPlots.length >= 1) {
        this.getPlots.forEach(plots => {
        })
      }
      return null
    },
    getFilters () {
      return this.$store.state.siteplan.filters
    },
    defaultLocation () {
      let development = null
      for (let i = 0; i < this.developments.length; i++) {
        if (this.$store.state.default !== '/') {
          if ('/' + this.developments[i].id === this.$store.state.default) {
            development = this.developments[i]
          }
        } else {
        }
      }
      return development
    },
    markers () {
      let markers = []
      let developmentsCopy = this.developments.slice()

      if (this.getFilters && this.getFilters.bedrooms === null) {
      } else {
        developmentsCopy.forEach(deve => {
          if (deve.bedrooms.includes(this.getFilters.bedrooms.toString())) {
          } else {
            developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
          }
        })
      }
      if (this.getFilters && this.getFilters.availability === null) {
      } else {
        developmentsCopy.forEach(deve => {
          const foundDevelopment = this.$store.getters.getPlots(deve.crm)
          if (foundDevelopment !== null) {
            let exists = false
            foundDevelopment.forEach(foundDev => {
              if (foundDev.StatusCode === this.getFilters.availability) {
                exists = true
              }
            })
            if (exists) {

            } else {
              developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
            }
          } else {
            developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
          }
        })
      }
      if (this.getFilters && this.getFilters.purchaseType === null) {
      } else {
        developmentsCopy.forEach(deve => {
          const foundDevelopment = this.$store.getters.getPlots(deve.crm)
          if (foundDevelopment !== null) {
            let exists = false
            foundDevelopment.forEach(foundDev => {
              if (foundDev.SellingType === this.getFilters.purchaseType) {
                exists = true
              }
            })
            if (exists) {

            } else {
              developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
            }
          } else {
            developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
          }
        })
      }
      if (this.getFilters && this.getFilters.style === null) {
      } else {
        developmentsCopy.forEach(deve => {
          const foundDevelopment = this.$store.getters.getPlots(deve.crm)
          if (foundDevelopment !== null) {
            let exists = false
            foundDevelopment.forEach(foundDev => {
              if (foundDev.HouseType === this.getFilters.style) {
                exists = true
              }
            })
            if (exists) {

            } else {
              developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
            }
          } else {
            developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
          }
        })
      }
      if (this.getFilters && this.getFilters.type === null) {
      } else {
        developmentsCopy.forEach(deve => {
          const foundDevelopment = this.$store.getters.getPlots(deve.crm)
          if (foundDevelopment !== null) {
            let exists = false
            foundDevelopment.forEach(foundDev => {
              if (foundDev.UnitType === this.getFilters.type) {
                exists = true
              }
            })
            if (exists) {

            } else {
              developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
            }
          } else {
            developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
          }
        })
      }
      if (this.getFilters && this.getFilters.price.max === null) {
      } else {
        developmentsCopy.forEach(deve => {
          const foundDevelopment = this.$store.getters.getPlots(deve.crm)
          if (foundDevelopment !== null) {
            let exists = false
            foundDevelopment.forEach(foundDev => {
              if ((Math.floor(foundDev.Price / 100000) * 100) >= this.getFilters.price.min && (Math.floor(foundDev.Price / 100000) * 100) <= this.getFilters.price.max) {
                exists = true
              }
            })
            if (exists) {

            } else {
              developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
            }
          } else {
            developmentsCopy = reject(developmentsCopy, function (o) { return o.id === deve.id })
          }
        })
      }
      for (let i = 0; i < developmentsCopy.length; i++) {
        if (this.defaultLocation) {
          let distance = null
          this.defaultLocation.distance.forEach(location => {
            if (location.development === developmentsCopy[i].id) {
              distance = location.distance
            }
          })
          const marker = {
            brand: developmentsCopy[i].brand,
            lat: parseFloat(developmentsCopy[i].location.lat),
            lng: parseFloat(developmentsCopy[i].location.lng),
            status: developmentsCopy[i].status,
            title: developmentsCopy[i].title,
            distance: distance
          }
          markers.push(marker)
        } else {
          const marker = {
            brand: developmentsCopy[i].brand,
            lat: parseFloat(developmentsCopy[i].location.lat),
            lng: parseFloat(developmentsCopy[i].location.lng),
            status: developmentsCopy[i].status,
            title: developmentsCopy[i].title
          }
          markers.push(marker)
        }
      }
      this.$store.commit('setMarkers', markers)
      return markers
    }
  },
  methods: {
    close () {
      this.active = null
      this.$refs.map.$mapPromise.then((map) => {
        map.setZoom(12)
      })
    },
    selectMarker (marker) {
      this.close()
      this.developmentDistance = marker.distance
      // avoid zoom on reclick without moving map
      const center = this.$refs.map.$mapObject.getCenter()
      const currentLat = (center.lat()).toFixed(6)
      const currentLng = (center.lng()).toFixed(6)
      if (marker.lat.toFixed(6) === currentLat && marker.lng.toFixed(6) === currentLng) {
        this.active = marker.title
      } else {
        let prevZoom = this.$refs.map.$mapObject.zoom
        this.$refs.map.$mapPromise.then((map) => {
          map.setZoom(prevZoom - 1)
        })
        this.$refs.map.$mapObject.panTo({ lat: marker.lat, lng: marker.lng })

        setTimeout(() => {
          this.$refs.map.$mapPromise.then((map) => {
            if (prevZoom > 12) {
              map.setZoom(prevZoom)
            } else {
              map.setZoom(12)
            }
          })
        }, 400)
        setTimeout(() => {
          this.active = marker.title
        }, 300)
      }
    },
    getMarkerIcon (marker) {
      const current = '/developments/' + marker.title.replace(/\s+/g, '-').toLowerCase()
      const brand = marker.brand
      const icons = this.map.markers[brand]
      if (this.$store.state.default === current) {
        return icons.current
      } else {
        if (marker.status === 'listed') {
          return icons.active
        } else {
          return icons.disabled
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // Returning from a development will refocus on that development when returning to the map
      if (vm.focusId !== null) {
        const focus = vm.developments.find(x => x.id === 'developments/' + vm.focusId)
        vm.$refs.map.$mapPromise.then((map) => {
          map.setZoom(12)
        })
        vm.$refs.map.$mapObject.panTo({ lat: parseFloat(focus.location.lat), lng: parseFloat(focus.location.lng) })
        vm.active = focus.title
      }
    })
  }
}
</script>
